module.exports = "/_next/static/images/Frame@2x-e81c63c316fe038890832248e1348e4d.png";